import React from 'react';
import HeroSection from './sections/HeroSection';
import SocialProofBar from './sections/SocialProofBar';
import ProblemSection from './sections/ProblemSection';
import SolutionSection from './sections/SolutionSection';
import HowItWorksSection from './sections/HowItWorksSection';
import BenefitsSection from './sections/BenefitsSection';
import TestimonialSection from './sections/TestimonialSection';
import OfferSection from './sections/OfferSection';
import FAQSection from './sections/FAQSection';
import FinalCTA from './sections/FinalCTA';
import Footer from './sections/Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <SocialProofBar />
      <ProblemSection />
      <SolutionSection />
      <HowItWorksSection />
      <BenefitsSection />
      <TestimonialSection />
      <OfferSection />
      <FAQSection />
      <FinalCTA />
      <Footer />
    </div>
  );
};

export default LandingPage;